// src/layouts/publish-here/components/PublishSteps/pdfUtils.js
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

// CONFIG DO WORKER (funciona no React / CRA / Vite)
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

// -------------------- UTIL --------------------

function ptsToCm(pts) {
  return (pts / 72) * 2.54;
}

export function cmToMm(cm) {
  if (!cm) return 0;
  return Number(cm) * 10;
}

/**
 * Fórmula da lombada (mm):
 *
 *   Lombada (mm) = (Número de páginas / 2) × Espessura do papel (µm) / 1000
 */
export function calculateSpineWidth(pages, paperThicknessMicron) {
  if (!pages || !paperThicknessMicron) return 0;
  return (pages / 2) * (paperThicknessMicron / 1000);
}

// Valores de espessura dos papéis (do print)
export const PAPER_TYPES = [
  { id: "offset_75", label: "Offset 75 g", grammage: 75, thicknessMicron: 100 },
  { id: "offset_90", label: "Offset 90 g", grammage: 90, thicknessMicron: 120 },
  { id: "couche_fosco_90", label: "Couché fosco 90 g", grammage: 90, thicknessMicron: 85 },
  { id: "couche_fosco_115", label: "Couché fosco 115 g", grammage: 115, thicknessMicron: 100 },
  { id: "couche_brilho_150", label: "Couché brilho 150 g", grammage: 150, thicknessMicron: 130 },
  { id: "polen_70", label: "Pólen 70 g", grammage: 70, thicknessMicron: 110 },
  { id: "polen_80", label: "Pólen 80 g", grammage: 80, thicknessMicron: 122 },
];

// -------------------- PDF --------------------

export async function extractPdfInfo(file) {
  const buffer = await file.arrayBuffer();

  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;

  const firstPage = await pdf.getPage(1);
  const viewport = firstPage.getViewport({ scale: 1 });
  let info = {};
  let metadata = null;
  try {
    const result = await pdf.getMetadata();
    info = result.info || {};
    metadata = result.metadata;
  } catch (error) {
    // Missing metadata does not prevent using the PDF's pages and dimensions.
  }
  const clean = (value) => {
    const text = Array.isArray(value) ? value.join("; ") : String(value || "");
    const trimmed = text.replace(/[\u0000-\u001f]/g, " ").trim();
    return /^(untitled|sem t[ií]tulo|unknown|desconhecido)$/i.test(trimmed) ? "" : trimmed;
  };
  const metadataTitle = clean(info.Title) || clean(metadata?.get("dc:title"));
  const metadataAuthor = clean(info.Author) || clean(metadata?.get("dc:creator"));

  return {
    pages: pdf.numPages,
    widthCm: Number(ptsToCm(viewport.width).toFixed(1)),
    heightCm: Number(ptsToCm(viewport.height).toFixed(1)),
    title:
      metadataTitle ||
      String(file.name || "")
        .replace(/\.pdf$/i, "")
        .replace(/_/g, " "),
    titleSource: metadataTitle ? "metadata" : "filename",
    author: metadataAuthor,
  };
}
